module.exports = __webpack_public_path__ + "static/img/014.c17d3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/014.png
// module id = Hylz
// module chunks = 0